import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSociety6Component } from './simple-icons-society6.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSociety6Component ],
    exports:      [ SimpleIconsSociety6Component ],
    bootstrap:    []
})
export class SimpleIconsSociety6Module {}
